<template>
  <div class="country-header">
    <div class="header-title">商品查询</div>
    <div class="header-right">
      <div class="search-box">
        <img
          class="search-img"
          @click="searchOrder"
          src="../../../../assets/imgs/work-wx/country/icon-search.svg"
        />
        <input
          class="search-input"
          v-model="searchText"
          maxlength="100"
          @keydown.enter="searchOrder"
          type="search"
          placeholder="搜索国家/地区"
        />
        <img
          class="delete-search"
          v-show="searchText"
          @click="clearSearch"
          src="../../../../assets/imgs/work-wx/country/btn-delete-text.svg"
        />
      </div>
    </div>
  </div>
</template>

<script>
import toast from '@/services/toast';
import countryApiService from '../services/country-api-service.js';

export default {
  components: {},
  data() {
    return {
      searchText: '',
      allCountryList: [],
    };
  },
  computed: {},
  created() {
    this.getAvailableCountryList();
  },
  methods: {
    getAvailableCountryList() {
      countryApiService.getAvailableCountryList().then((res) => {
        this.allCountryList = res.result;
      });
    },
    clearSearch() {
      this.searchText = '';
    },
    searchOrder() {
      if (!this.searchText) return;
      const query = this.searchText.toLowerCase();
      const searchCountryList = this.allCountryList.filter(
        (v) =>
          v.cn_country.indexOf(query) > -1 ||
          v.en_country.toLowerCase().indexOf(query) > -1 ||
          v.country.indexOf(query) > -1,
      );
      if (searchCountryList && searchCountryList.length) {
        this.$emit('changeSelectCountry', searchCountryList[0].visa_country_id);
        this.clearSearch();
      } else {
        toast.show('未找到指定国家');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.country-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 16px;
  border-bottom: 1px solid #ededed;
  background-color: white;
  .header-title {
    font-size: 14px;
    color: #222;
    font-weight: bold;
  }
  .search-box {
    display: flex;
    align-items: center;
    background: #f0f2f7;
    border-radius: 14px;
    padding: 0 10px;
    width: 138 px;
    height: 30px;
    .search-img {
      width: 18px;
      height: 18px;
      margin-right: 6px;
    }
    .search-input {
      width: 100px;
      outline: none;
      border: none;
      background-color: transparent;
      font-size: 14px;
      color: #2c3344;
      line-height: 20px;
      padding: 0;
      margin: 0;
      -webkit-appearance: none;
    }
    .delete-search {
      cursor: pointer;
      width: 15px;
      height: 15px;
    }
    ::-webkit-input-placeholder {
      color: #717785;
    }
    :-moz-placeholder {
      color: #717785;
    }
    ::-moz-placeholder {
      color: #717785;
    }
    :-ms-input-placeholder {
      color: #717785;
    }
  }
}
</style>
